import {
    SHOW_RESTAURANT_MODAL,
    HIDE_RESTAURANT_MODAL,
    DELETE_BRANCH
} from './restaurantDetails.actionsTypes';

export default function restaurantDetails(state = {}, action) {
	let newState = Object.assign({}, state);
	switch (action.type) {
		case SHOW_RESTAURANT_MODAL:
			const { restaurant } = action;
			return {
				...restaurant,
				show: true
			};
		case HIDE_RESTAURANT_MODAL:
			return {
				...newState,
				restaurant: null,
				show: false
			};
		case DELETE_BRANCH:
			return {
				...newState,
				branches: newState.branches.map(branch => {
					return branch._id === action.branchId ? {
						...branch,
						deleted: true
					} : branch
				})
			};
		default:
			return newState;
	}
}